var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',_vm._g(_vm._b({},'el-tooltip',_vm.$attrs,false),_vm.$listeners),[_c('i',{class:['color-gray-7', _setup.iconClazz],style:({transform: `translateY(${_setup.positionTop})`})}),_vm._l((_setup.slotKeys),function(item){return _c('template',{slot:item},[_vm._t(item)],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }